import React, { useEffect, useState } from "react";
import TableRow from "../../../../Helpers/Table/TableRow";
import Empty from "../../../../Helpers/Empty/Empty";
import TableActions from "../../../../Helpers/Table/TableActions2";
import CategoryPopup from "../../../../Setup/categories/popup/CategoryPopup";
import TableChildren from "../../../../Helpers/Table/TableChildren";
import CustomTag from "../../../../Helpers/Tag/Tag";

const UpcomingTableBody = ({ data }) => {
  const [showId, setShowId] = useState("");
  const onClose = () => {
    setShowId("");
  };

  const getTagColor = (status) => {
    switch (status) {
      case "Pending":
        return "red";
      case "Upcoming":
        return "magenta";
      case "Done":
        return "green";
      case "Waiting":
        return "geekblue";
      default:
        return "purple"; // Fallback color
    }
  };

  if (!data) return <Empty title="No Upcoming Maintenance Found" />;

  return (
    <>
      {data?.map((i) => {
        const tagColor = getTagColor(i.status);
        return (
          <div key={i.id} className="table-row">
            <TableRow value={i.code} />
            <TableRow value={i.vehicle} style="table-element-code ps-0" />
            <TableRow value={i.workshop} />
            <TableChildren>
              <CustomTag text={i.status} color={tagColor} />
            </TableChildren>
            <TableRow value={i.start} />
            <TableRow value={i.estimation} />
            <TableRow
              value={i.description ? i.description : "- - - -"}
              valuestyle={"truncate-2-lines"}
            />
            <TableActions setShowId={setShowId} data={i} button1="Eye" />
          </div>
        );
      })}
      {!!showId && (
        <CategoryPopup
          id={showId.id}
          data={showId}
          onClose={onClose}
          title={showId.name}
        />
      )}
    </>
  );
};

export default UpcomingTableBody;
